import { MapType } from 'features/maps/types'
import { getQFromQuery, buildAnalysisQueryFromSource, increaseQueriesNumber, isAnalysis } from '../../utils'

export function addGeomColumn({ sourceDataset, columnsValueMain }) {
  const geomColumn = sourceDataset.metadata?.schema?.find((field) => {
    return field.type === 'geometry'
  })
  const needsGeomColumn = columnsValueMain?.length && !columnsValueMain.includes(geomColumn.name)
  if (needsGeomColumn && geomColumn) {
    columnsValueMain.push(`${geomColumn.name}`)
  }
}

export function addJoinColumn({ columnsValueMain, sourceColumn }) {
  const needsJoinColumn = columnsValueMain?.length && !columnsValueMain.includes(sourceColumn)
  if (needsJoinColumn) {
    columnsValueMain.push(sourceColumn)
  }
}

export function getNonDuplicatedColumns({ newTableSecondSourceColumns, columnsValueMain }) {
  return newTableSecondSourceColumns?.map((column) => {
    const columnExists = columnsValueMain?.includes(column.value)
    const columnAlreadyRenamed = columnsValueMain?.filter((e) => {
      return new RegExp('(' + column.value + ')(_)(\\d*)', 'g').test(e)
    })
    const onlyNumbers: number[] = []
    columnAlreadyRenamed?.forEach((col) => {
      const regExp = new RegExp('(' + column.value + ')*(_)(\\d*)', 'g')
      const aNumber = col.replace(regExp, (g1) => {
        const splitColumn = g1.split('_')
        return splitColumn ? (splitColumn[splitColumn.length - 1] as number) : 0
      })
      onlyNumbers.push(parseInt(aNumber))
    })
    const latest =
      onlyNumbers?.length &&
      onlyNumbers?.reduce((a, b) => {
        return Math.max(a, b)
      })
    return columnExists && !columnAlreadyRenamed?.length
      ? `${column.value} as ${column.value}_2`
      : // eslint-disable-next-line no-extra-boolean-cast
      Boolean(columnAlreadyRenamed?.length && latest)
      ? `${column.value} as ${column.value}_${latest + 1}`
      : `${column.value}`
  })
}

export const generateQuery = ({ mainColumns, secondColumns, base, second, joinBy }) => {
  const qBase = buildAnalysisQueryFromSource({ source: base })
  let qSecond = buildAnalysisQueryFromSource({ source: second, wrapWith: false, lastQNumber: getQFromQuery(qBase) })
  const isSecondAnalysis = second?.type === MapType.query && isAnalysis(second?.source)
  if (isSecondAnalysis) {
    const lastQNumber = getQFromQuery(qBase)
    qSecond = qSecond.replace(/WITH __q1 AS \(/, '__q1 AS (')
    qSecond = increaseQueriesNumber(qSecond, lastQNumber)
  }
  const qBaseNumber = getQFromQuery(qBase) || 1
  const qSecondNumber = getQFromQuery(qSecond) || 2
  const nextQNumber = qSecondNumber + 1
  const query = `${qBase},\n${qSecond},
__q${nextQNumber} AS (
\tSELECT
\t\t${mainColumns?.length ? mainColumns?.join(',\n') : 'base.*'},
\t\t${secondColumns?.length ? secondColumns?.join(',\n') : ''}
\tFROM
\t\t__q${qBaseNumber} AS base
\tLEFT JOIN
\t\t__q${qSecondNumber} AS second
\tON
\t\t${joinBy}
)
SELECT * FROM __q${nextQNumber}`

  return query
}

/**
 * Check that the columnName does not exist in the columns array
 * if it does it adds "_N" where N will be the number for next occur
 * @param { columnName: string, columns: string[] }
 * @returns string
 */
export function getUniqueColumnName({ columnName, columns }) {
  const columnExists = columns?.includes(columnName)
  const columnAlreadyRenamed = columns?.filter((e) => {
    return new RegExp('(' + columnName + ')(_)(\\d*)', 'g').test(e)
  })
  const onlyNumbers: number[] = []
  columnAlreadyRenamed?.forEach((col) => {
    const regExp = new RegExp('(' + columnName + ')*(_)(\\d*)', 'g')
    const aNumber = col.replace(regExp, (g1) => {
      const splitColumn = g1.split('_')
      return splitColumn ? (splitColumn[splitColumn.length - 1] as number) : 0
    })
    onlyNumbers.push(parseInt(aNumber))
  })
  const latest =
    onlyNumbers?.length &&
    onlyNumbers?.reduce((a, b) => {
      return Math.max(a, b)
    })
  return columnExists && !columnAlreadyRenamed?.length
    ? `${columnName}_2`
    : // eslint-disable-next-line no-extra-boolean-cast
    Boolean(columnAlreadyRenamed?.length && latest)
    ? `${columnName}_${latest + 1}`
    : `${columnName}`
}
